import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";

function PlayerStatsSMP() {
  return (
    <Box sx={{ flexGrow: 1, py: 4 }}>
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            26K Days Permanent Survival SMP Stats
          </Typography>

          <Box
            component="iframe"
            src="https://www.mcverse.city/stats-smp/index.html#hof"
            sx={{
              width: "100%",
              height: "70vh",
              border: "none",
              borderRadius: "4px",
              mt: 2,
              mb: 2,
              boxShadow: 2,
            }}
            title="MCVerse SMP Stats"
            allowFullScreen
          />
        </Paper>
      </Container>
    </Box>
  );
}

export default PlayerStatsSMP;
